import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../routes/AppContext";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

function getSnippets(gtm: string) {
  return {
    iframe: `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtm}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
    script: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtm}');`,
  };
}

export function useTagManager(gtm: string) {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Google Tag Manger only available in PRODUCTION ENV
    if (process.env.REACT_APP_ENV_TYPE === "prod") {
      const snippets = getSnippets(gtm);

      const noscript = document.createElement("noscript");
      noscript.innerHTML = snippets.iframe;

      const script = document.createElement("script");
      script.innerHTML = snippets.script;

      document.head.insertBefore(script, document.head.childNodes[0]);
      document.body.insertBefore(noscript, document.body.childNodes[0]);

      setLoading(false);

      return () => {
        document.head.removeChild(script);
        document.body.removeChild(noscript);

        // Remove the script that GTM script adding
        const scriptTags = document.head.getElementsByTagName("script");
        for (let scriptTag of scriptTags) {
          if (scriptTag?.src.includes(gtm)) {
            document.head.removeChild(scriptTag);
          }
        }
      };
    } else {
      console.warn("Google Tag Manger only available in PRODUCTION ENV");
    }
  }, [gtm]);

  const dataLayer = (data: any) => {
    // Google Tag Manger only available in PRODUCTION ENV
    if (process.env.REACT_APP_ENV_TYPE === "prod") {
      if (!loading) {
        window.dataLayer.push(data);
      } else {
        console.warn("Google Tag Manager script didn't load");
      }
    } else {
      console.warn("Google Tag Manger only available in PRODUCTION ENV");
      console.log("data-layer ->", JSON.stringify(data));
    }
  };

  return { dataLayer };
}
